import { useCallback, useMemo } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";

export function useApiClient() {
  const { inProgress } = useMsal();
  const ready = inProgress === InteractionStatus.None;

  const call = useCallback(
    async <T,>(fn: (...args: any[]) => Promise<T>, ...args: any[]): Promise<T | null> => {
      if (!ready) {
        console.warn("API call attempted before MSAL was ready.");
        return null;
      }

      try {
        const result = await fn(...args);
        return result;
      } catch (err) {
        console.error("API call error:", err);
        throw err;
      }
    },
    [ready]
  );

  return useMemo(() => ({ call, ready }), [call, ready]);
}
